import axiosInstance from "./axiosInstance";

export const fetchFleets = async () => {
  return await axiosInstance.get(`/fleets/list`);
};

export const createFleet = async (data) => {
  return await axiosInstance.post(`/admin/fleets/create`, data);
};

export const updateFleet = async (id, data) => {
  return await axiosInstance.put(`/admin/fleets/update/${id}`, data);
};

export const deleteFleet = async (id) => {
  return await axiosInstance.delete(`/admin/fleets/delete/${id}`);
};

export const fetchFleetDetails = async (id) => {
  return await axiosInstance.get(`/admin/fleets/details/${id}`);
};

export const getAllFleets = async (filters = {}) => {
  const queryParams = new URLSearchParams();
  console.log("Filters being sent:", filters);

  if (filters.fleetId) queryParams.append("fleetId", filters.fleetId);

  // Only add filter parameters if they have values
  if (filters.status && filters.status.length > 0) {
    queryParams.append(
      "status",
      filters.status.map((s) => s.toLowerCase()).join(",")
    );
  }
  if (filters.loadCondition && filters.loadCondition.length > 0) {
    queryParams.append(
      "loadCondition",
      filters.loadCondition.map((l) => l.toLowerCase()).join(",")
    );
  }
  if (filters.weather && filters.weather.length > 0) {
    queryParams.append(
      "weather",
      filters.weather.map((w) => w.toLowerCase()).join(",")
    );
  }
  if (filters.zone && filters.zone.length > 0) {
    queryParams.append(
      "zone",
      filters.zone.map((z) => z.toLowerCase()).join(",")
    );
  }

  const url = `/fleets/list${
    queryParams.toString() ? `?${queryParams.toString()}` : ""
  }`;
  console.log("API URL:", url);

  const res = await axiosInstance.get(url);
  return res.data;
};

export const downloadVesselFiles = async (file) => {
  try {
    const response = await axiosInstance.get(
      `/admin/vessel/files/download?filePath=${encodeURIComponent(file.path)}`,
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name || "downloaded_file";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return response;
  } catch (error) {
    console.error("Download error:", error);
    throw new Error(error.response?.data?.message || "Failed to download file");
  }
};
